export default () => ({
  root: {
    flexGrow: 1,
    overflow: 'auto',
  },
  textArea: {
    padding: 20,
    border: 'none',
    outline: 'none',
    fontSize: 16,
    resize: 'none',
    width: '100%',
    font: '16px neuzeit-grotesk',
  },
});
